import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isInternalRoute } from "@/lib/internalRoutes";

/**
 * Injects <meta name="robots" content="noindex,nofollow"> on any
 * internal/back-office route so Googlebot drops these URLs from the index.
 * Pair with allowing crawl in robots.txt (otherwise the bot can't see this tag).
 */
export function NoIndexInternal() {
  const { pathname } = useLocation();
  if (!isInternalRoute(pathname)) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex,nofollow" />
      <meta name="googlebot" content="noindex,nofollow" />
    </Helmet>
  );
}
